/* unplugin-vue-components disabled */import script from "./todoList.vue?vue&type=script&setup=true&lang=js"
export * from "./todoList.vue?vue&type=script&setup=true&lang=js"

import "./todoList.vue?vue&type=style&index=0&id=5ab223cb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ab223cb"]])

export default __exports__